module.exports = __webpack_public_path__ + "img/promo-takeaway15-home.56417cec.jpeg";